import { z } from "zod/v4";

import { ExperiencePageTargetingDtoSchema } from "../dtos/experience-page-targeting";

export const ExperiencePageTargetingFeSchema =
  ExperiencePageTargetingDtoSchema.extend({
    experienceId: z.uuid().optional(),
  });

export type ExperiencePageTargetingFe = z.infer<
  typeof ExperiencePageTargetingFeSchema
>;
